export default {
    methods: {
        getNestedValue(object, path) {
            if (!object || !path) return undefined;
            return path.replace(/\[(\w+)\]/g, '.$1').split('.').reduce((acc, key) => acc?.[key], object);
        },
        setNestedValue(obj, path, value) {
            if (!obj || !path) return;
            const keys = path.replace(/\[(\w+)\]/g, '.$1').split('.');
            const lastKey = keys.pop();
            const lastObj = keys.reduce((acc, key) => acc[key] = acc[key] || {}, obj);
            lastObj[lastKey] = value;
        }
    }
};